module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div id="login_container" class="login_' +
((__t = ( source )) == null ? '' : __t) +
'">\n	<div id="login_logo"></div>\n	<div id="login_instruction"><span></span></div>\n	<div id="login_button"><b><span></span></b></div>\n</div>';

}
return __p
}